const routes = [
    {
        path: '/area_cliente_adm/clientes/index',
        alias: '/area_cliente_adm/clientes',
        component: () => import('../views/Listar')
    },
    {
        path: '/area_cliente_adm/clientes/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        path: '/area_cliente_adm/clientes/visualizar/:id',
        component: () => import('../views/Visualizar')
    },
    {
        path: '/area_cliente_adm/clientes/editar/:id',
        component: () => import('../views/Editar')
    }
]

export default routes
